<template>
  <div v-if="selectedAwardAmount" class="cart-info">
    <h3 v-text="translate('lblCartInfo', { count: selectedAwardAmount })"></h3>
    <a :href="cartUrl" class="my-2 my-m-0 button button--medium button--primary" v-text="translate('btnGoToCart')"></a>
  </div>
</template>

<script>
export default {
  name: 'SelectedAwardAmountIcon',
  data: () => ({
    selectedAwardAmount: 0,
    apiError: false,
  }),
  props: {
    cartUrl: String,
  },
  methods: {
    updateNumberOfCartItems() {
      const storedList = JSON.parse(sessionStorage.getItem('selectedAwardItems'));
      if (storedList) {
        this.selectedAwardAmount = storedList.reduce((prev, curr) => prev + parseInt(curr.amount, 10), 0);
      }
    },
  },
  created() {
    this.updateNumberOfCartItems();
  },
};
</script>

<style scoped lang="scss">
.cart-info {
  background-color: $color-kws-gray-100;
  margin-bottom: rem(32px);
  padding: rem(16px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;

  h3 {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: rem(24px);
    line-height: 1.5;
    font-weight: 700;
    color: $color-white;
    margin: 0;
    flex-grow: 99999;
  }

  a.button {
    flex-grow: 1;
  }
}
</style>
